import { Component, OnInit, Input } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { TooltipFocusDirective } from '../../directives/tooltip-focus.directive';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.css'],
    imports: [Tooltip, TooltipFocusDirective]
})
export class TooltipComponent implements OnInit {

    @Input() tooltipText!: string;
    @Input() tooltipIsContainer: boolean = false;
    @Input() error = false;

    constructor() { }

    ngOnInit(): void { }
}
